import { useTranslations } from '@/i18n/useTranslations';

import Link from 'next/link';
import styles from './NeoTag.module.sass';

export default function NeoTag() {
  const { t } = useTranslations('LoginPage');

  return (
    <Link
      className={styles.neotag}
      href="https://t.me/neovpn?start"
      target="_blank"
    >
      @neovpn
    </Link>
  );
}
